import Vue from "vue";
import VueLocalStorage from "vue-localstorage";

Vue.use(VueLocalStorage, {
  bind: true,
});
